import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, SparklesIcon, EyeIcon, SlidersHorizontalIcon, HeartIcon } from 'lucide-react';
const checkVariants = {
  hidden: {
    opacity: 0,
    scale: 0.5
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 20
    }
  }
};
const listContainerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const listItemVariants = {
  hidden: {
    opacity: 0,
    x: -12
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
export function OfferSection() {
  return <section className="w-full" data-id="element-141">
      {/* La promesa */}
      <div className="py-16 md:py-24 px-6" style={{
      backgroundColor: 'var(--cream)'
    }} data-id="element-142">
        <div className="max-w-2xl mx-auto" data-id="element-143">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="mb-12" data-id="element-144">
            <p className="text-sm font-semibold uppercase tracking-widest mb-4" style={{
            color: 'var(--gold)'
          }} data-id="element-145">
              La promesa (sin humo)
            </p>
            <h2 className="font-serif text-2xl md:text-3xl mb-6" style={{
            color: 'var(--navy)'
          }} data-id="element-146">
              En 14 días vas a instalar un sistema simple para:
            </h2>
            <ul className="space-y-3 text-base md:text-lg" style={{
            color: 'var(--charcoal)',
            lineHeight: '1.7'
          }} data-id="element-147">
              <li className="flex items-start gap-3" data-id="element-148">
                <span className="mt-2 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
                backgroundColor: 'var(--gold)'
              }} data-id="element-149" />
                dejar de mezclar tu dinero (y que se "desaparezca"),
              </li>
              <li className="flex items-start gap-3" data-id="element-150">
                <span className="mt-2 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
                backgroundColor: 'var(--gold)'
              }} data-id="element-151" />
                poner fricción real contra compras impulsivas,
              </li>
              <li className="flex items-start gap-3" data-id="element-152">
                <span className="mt-2 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
                backgroundColor: 'var(--gold)'
              }} data-id="element-153" />
                y empezar a ver progreso en tus tarjetas sin sentirte
                castigada/o.
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="space-y-4 text-base md:text-lg" style={{
          color: 'var(--charcoal)',
          lineHeight: '1.8'
        }} data-id="element-154">
            <p data-id="element-155">No te voy a pedir que registres cada café por 6 meses.</p>
            <p data-id="element-156">No te voy a vender "motivación".</p>
            <p className="font-medium" style={{
            color: 'var(--navy)'
          }} data-id="element-157">
              Te voy a dar un sistema.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Qué recibes */}
      <div className="py-16 md:py-24 px-6" style={{
      backgroundColor: 'var(--light-navy)'
    }} data-id="element-158">
        <div className="max-w-2xl mx-auto" data-id="element-159">
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="font-serif text-2xl md:text-3xl mb-10" style={{
          color: 'var(--navy)'
        }} data-id="element-160">
            Qué recibes
          </motion.h2>

          <div className="md:flex md:items-start md:gap-10" data-id="element-161">
            {/* Checklist */}
            <motion.ul variants={listContainerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true,
            margin: '-40px'
          }} className="space-y-4 mb-10 md:mb-0 md:flex-1" role="list" data-id="element-162">
              <motion.li variants={listItemVariants} className="flex items-start gap-3" data-id="element-163">
                <motion.span variants={checkVariants} className="mt-0.5 flex-shrink-0" data-id="element-164">
                  <CheckIcon className="w-5 h-5" style={{
                  color: 'var(--green)'
                }} data-id="element-165" />
                </motion.span>
                <span className="text-base" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.7'
              }} data-id="element-166">
                  <strong style={{
                  color: 'var(--navy)'
                }} data-id="element-167">
                    Guía completa paso a paso
                  </strong>{' '}
                  — Reset de Deudas en 14 Días (PDF)
                </span>
              </motion.li>
              <motion.li variants={listItemVariants} className="flex items-start gap-3" data-id="element-168">
                <motion.span variants={checkVariants} className="mt-0.5 flex-shrink-0" data-id="element-169">
                  <CheckIcon className="w-5 h-5" style={{
                  color: 'var(--green)'
                }} data-id="element-170" />
                </motion.span>
                <span className="text-base" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.7'
              }} data-id="element-171">
                  <strong style={{
                  color: 'var(--navy)'
                }} data-id="element-172">
                    Checklists diarios
                  </strong>{' '}
                  — Día 1 al 14
                </span>
              </motion.li>
              <motion.li variants={listItemVariants} className="flex items-start gap-3" data-id="element-173">
                <motion.span variants={checkVariants} className="mt-0.5 flex-shrink-0" data-id="element-174">
                  <CheckIcon className="w-5 h-5" style={{
                  color: 'var(--green)'
                }} data-id="element-175" />
                </motion.span>
                <span className="text-base" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.7'
              }} data-id="element-176">
                  <strong style={{
                  color: 'var(--navy)'
                }} data-id="element-177">
                    Plantillas listas para usar
                  </strong>{' '}
                  — 3‑Cuentas + tracker de deuda
                </span>
              </motion.li>
              <motion.li variants={listItemVariants} className="flex items-start gap-3" data-id="element-178">
                <motion.span variants={checkVariants} className="mt-0.5 flex-shrink-0" data-id="element-179">
                  <CheckIcon className="w-5 h-5" style={{
                  color: 'var(--green)'
                }} data-id="element-180" />
                </motion.span>
                <span className="text-base" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.7'
              }} data-id="element-181">
                  <strong style={{
                  color: 'var(--navy)'
                }} data-id="element-182">
                    Protocolo anti‑recaída
                  </strong>{' '}
                  — sin tirar todo
                </span>
              </motion.li>
            </motion.ul>

            {/* Product Image */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="md:w-64 flex-shrink-0" data-id="element-183">
              <img src="https://cdn.magicpatterns.com/uploads/eiw3Ahp72PQNF5GmDcpK98/RESET_DE_DEUDAS_EN_14_DIAS_USA_.png" alt="Reset de Deudas en 14 Días (USA) — vista previa del producto con checklist y plantillas" className="w-full rounded-xl shadow-lg" data-id="element-184" />
            </motion.div>
          </div>

          {/* Time callout */}
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="mt-10 px-6 py-4 rounded-xl text-center" style={{
          backgroundColor: 'rgba(200, 164, 92, 0.1)',
          border: '1px solid rgba(200, 164, 92, 0.25)'
        }} data-id="element-185">
            <p className="text-base font-medium" style={{
            color: 'var(--navy)'
          }} data-id="element-186">
              ⏱ Tiempo real requerido: <strong data-id="element-187">10–15 min/día</strong>
            </p>
          </motion.div>
        </div>
      </div>

      {/* Para quién es / para quién no es */}
      <div className="py-16 md:py-24 px-6" style={{
      backgroundColor: 'var(--cream)'
    }} data-id="element-188">
        <div className="max-w-2xl mx-auto" data-id="element-189">
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="font-serif text-2xl md:text-3xl mb-10" style={{
          color: 'var(--navy)'
        }} data-id="element-190">
            Para quién es / para quién no es
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-191">
            {/* Es para ti */}
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.5
          }} className="p-6 rounded-xl" style={{
            backgroundColor: 'rgba(74, 124, 89, 0.06)',
            border: '1px solid rgba(74, 124, 89, 0.15)'
          }} data-id="element-192">
              <h3 className="font-semibold text-base mb-4" style={{
              color: 'var(--green)'
            }} data-id="element-193">
                ✅ Es para ti si:
              </h3>
              <ul className="space-y-3" data-id="element-194">
                <li className="flex items-start gap-2 text-sm" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.6'
              }} data-id="element-195">
                  <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: 'var(--green)'
                }} data-id="element-196" />
                  Vives en USA, hablas español, tienes 35+
                </li>
                <li className="flex items-start gap-2 text-sm" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.6'
              }} data-id="element-197">
                  <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: 'var(--green)'
                }} data-id="element-198" />
                  Tienes deuda (sobre todo tarjetas)
                </li>
                <li className="flex items-start gap-2 text-sm" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.6'
              }} data-id="element-199">
                  <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: 'var(--green)'
                }} data-id="element-200" />
                  Te identificas con compras impulsivas por estrés/cansancio
                </li>
                <li className="flex items-start gap-2 text-sm" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.6'
              }} data-id="element-201">
                  <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: 'var(--green)'
                }} data-id="element-202" />
                  Quieres orden sin apps complicadas
                </li>
              </ul>
            </motion.div>

            {/* No es para ti */}
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.5,
            delay: 0.15
          }} className="p-6 rounded-xl" style={{
            backgroundColor: 'rgba(180, 60, 60, 0.04)',
            border: '1px solid rgba(180, 60, 60, 0.12)'
          }} data-id="element-203">
              <h3 className="font-semibold text-base mb-4" style={{
              color: '#8B3A3A'
            }} data-id="element-204">
                ❌ No es para ti si:
              </h3>
              <ul className="space-y-3" data-id="element-205">
                <li className="flex items-start gap-2 text-sm" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.6'
              }} data-id="element-206">
                  <XIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#8B3A3A'
                }} data-id="element-207" />
                  Buscas invertir o hacer trading
                </li>
                <li className="flex items-start gap-2 text-sm" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.6'
              }} data-id="element-208">
                  <XIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#8B3A3A'
                }} data-id="element-209" />
                  Necesitas asesoría legal/fiscal
                </li>
                <li className="flex items-start gap-2 text-sm" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.6'
              }} data-id="element-210">
                  <XIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#8B3A3A'
                }} data-id="element-211" />
                  No tienes ingreso (ahí el plan debe ser otro primero)
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Lo que cambia */}
      <div className="py-16 md:py-20 px-6" style={{
      backgroundColor: 'var(--cream)'
    }} data-id="element-212">
        <div className="max-w-2xl mx-auto" data-id="element-213">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="mb-10" data-id="element-214">
            <h2 className="font-serif text-2xl md:text-3xl mb-3" style={{
            color: 'var(--navy)'
          }} data-id="element-215">
              Lo que cambia
            </h2>
            <p className="text-base" style={{
            color: 'var(--charcoal)',
            opacity: 0.7,
            lineHeight: '1.7'
          }} data-id="element-216">
              No prometo "ser millonaria/o". Prometo algo más útil:
            </p>
          </motion.div>

          <motion.div variants={listContainerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-217">
            <motion.div variants={listItemVariants} className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: 'white',
            border: '1px solid rgba(27, 42, 74, 0.06)'
          }} data-id="element-218">
              <EyeIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
              color: 'var(--gold)'
            }} data-id="element-219" />
              <div data-id="element-220">
                <p className="font-semibold text-sm mb-1" style={{
                color: 'var(--navy)'
              }} data-id="element-221">
                  Claridad
                </p>
                <p className="text-sm" style={{
                color: 'var(--charcoal)',
                opacity: 0.7,
                lineHeight: '1.6'
              }} data-id="element-222">
                  Saber dónde está tu dinero
                </p>
              </div>
            </motion.div>

            <motion.div variants={listItemVariants} className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: 'white',
            border: '1px solid rgba(27, 42, 74, 0.06)'
          }} data-id="element-223">
              <SlidersHorizontalIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
              color: 'var(--gold)'
            }} data-id="element-224" />
              <div data-id="element-225">
                <p className="font-semibold text-sm mb-1" style={{
                color: 'var(--navy)'
              }} data-id="element-226">
                  Control
                </p>
                <p className="text-sm" style={{
                color: 'var(--charcoal)',
                opacity: 0.7,
                lineHeight: '1.6'
              }} data-id="element-227">
                  No vivir en niebla
                </p>
              </div>
            </motion.div>

            <motion.div variants={listItemVariants} className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: 'white',
            border: '1px solid rgba(27, 42, 74, 0.06)'
          }} data-id="element-228">
              <SparklesIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
              color: 'var(--gold)'
            }} data-id="element-229" />
              <div data-id="element-230">
                <p className="font-semibold text-sm mb-1" style={{
                color: 'var(--navy)'
              }} data-id="element-231">
                  Progreso
                </p>
                <p className="text-sm" style={{
                color: 'var(--charcoal)',
                opacity: 0.7,
                lineHeight: '1.6'
              }} data-id="element-232">
                  Ver que la deuda se mueve
                </p>
              </div>
            </motion.div>

            <motion.div variants={listItemVariants} className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: 'white',
            border: '1px solid rgba(27, 42, 74, 0.06)'
          }} data-id="element-233">
              <HeartIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
              color: 'var(--gold)'
            }} data-id="element-234" />
              <div data-id="element-235">
                <p className="font-semibold text-sm mb-1" style={{
                color: 'var(--navy)'
              }} data-id="element-236">
                  Paz
                </p>
                <p className="text-sm" style={{
                color: 'var(--charcoal)',
                opacity: 0.7,
                lineHeight: '1.6'
              }} data-id="element-237">
                  Sin estar huyendo del banco
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}